<template>
    <v-card class="card-content" outlined>
        <div class="title-button-container">
            <h4 class="titulo">{{ titulo }}</h4>
            <v-btn v-if="showCsvButton" small class="csv-button" @click="$emit('export-csv')">
                CSV
            </v-btn>
        </div>
        <div class="valor-resumen" :class="{ 'valor-resumen--stacked': stacked }">
            <span class="first-value">{{ firstValue }}</span>
            <span class="second-value">
                <slot name="second-value">{{ secondValue }}</slot>
            </span>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'CardResumeCompanyDetails',
    props: {
        titulo: String,
        firstValue: String,
        secondValue: String,
        showCsvButton: {
            type: Boolean,
            default: true
        },
        /**
         * Baja el texto secundario a su propia línea en vez de dejarlo
         * pegado al monto. Opt-in: las tarjetas que ya existían lo quieren
         * en línea y no deben cambiar de aspecto por esto.
         */
        stacked: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.card-content {
    padding: 10px !important;
}

.title-button-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
}

.valor-resumen {
    display: flex;
    align-items: baseline;
    margin-top: 5px;
}

.valor-resumen--stacked {
    flex-direction: column;
    align-items: flex-start;
}

/* El margen lateral que separa monto y texto sobra cuando quedan apilados. */
.valor-resumen--stacked .first-value {
    margin-right: 0;
    line-height: 1.2;
}

.first-value {
    font-size: 26px;
    font-weight: 700;
    margin-right: 4px;
    color: #104B94;
}

.second-value {
    font-size: 14px;
    color: #8593A3;
}

.csv-button {
    background-color: #4CAF50 !important;
    color: #FFFFFF !important;
    height: 29px !important;
    font-family: Inter;
}

.titulo {
    font-family: Inter;
    color: #1B1D21;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0 !important;
    /* Elimina el margen inferior por defecto */
}
</style>